import React from "react";
import { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Avatar,
  Rating,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import axios from "axios";
const DESCO_API_BASE = import.meta.env.VITE_DESCO_API_BASE;

dayjs.extend(relativeTime);

// Styled components
const StyledHeading = styled(Typography)(({ theme }) => ({
  color: "#0F172A",
  fontWeight: 700,
  marginBottom: theme.spacing(1),
}));

const StyledSubheading = styled(Typography)(({ theme }) => ({
  color: "#64748B",
  marginBottom: theme.spacing(4),
}));

const ViewAllButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#C10E14",
  color: "white",
  borderRadius: theme.spacing(0.5),
  "&:hover": {
    backgroundColor: "#C10E19",
  },
}));

const TestimonialCard = styled(Card)(({ theme }) => ({
  height: "100%",
  boxShadow: "none",
  border: "1px solid #E2E8F0",
  borderRadius: theme.spacing(1),
}));

const TestimonialHeading = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: "#0F172A",
  marginBottom: theme.spacing(2),
}));

const StyledRating = styled(Rating)({
  color: "#FFA723",
  marginBottom: 16,
});

// Testimonial data
const testimonials = [
  {
    id: 1,
    name: "Ameer A.",
    created_at: "2025-05-21T04:19:17.000000Z",
    rating: 5,
    title: "Best Buyers in No Time",
    content:
      "From listing to closing, Provident provided excellent service. They marketed my property effectively and brought in serious buyers within days.",
  },
  {
    id: 2,
    name: "Karen F.",
    created_at: "2025-05-21T04:19:17.000000Z",
    rating: 5,
    title: "Seamless Sales Process",
    content:
      "Provident's expertise helped me get the best value for my home. Their marketing efforts were amazing, and the sale process was seamless.",
  },
  {
    id: 3,
    name: "Mark H.",
    created_at: "2025-05-21T04:19:17.000000Z",
    rating: 5,
    title: "Smart and Effective Service",
    content:
      "The entire process was quick and efficient. The Provident's team took care of everything from marketing to negotiating offers. I'm delighted with their work.",
  },
];

const TestimonialsSection = () => {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const getReviews = async () => {
      const response = await axios.get(
        `${DESCO_API_BASE}/review/index`
      );

      setReviews(response.data?.data?.reviews);
    };

    getReviews();
  }, []);
 
console.log("reviews",reviews)

  return (
    <Box sx={{ pt: 6 }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Box>
            <StyledHeading variant="h4">Why Our Clients Trust Us</StyledHeading>
            <StyledSubheading variant="body1">
              Discover what our customers are saying about their experiences.
            </StyledSubheading>
          </Box>
          <ViewAllButton
            variant="contained"
            endIcon={<ArrowForwardIosIcon fontSize="small" />}
            onClick={() => navigate("/testimonials")}
          >
            See all reviews
          </ViewAllButton>
        </Box>

        <Grid container spacing={3}>
          {reviews?.slice(0,3).map((testimonial) => (
            <Grid item xs={12} md={4} key={testimonial.id}>
              <TestimonialCard>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Avatar
                      sx={{
                        bgcolor: "#C10E14",
                        width: 48,
                        height: 48,
                        mr: 2,
                      }} 
                       src={`https://project.trogon.info/desco/${testimonial?.avatar}`} 
                    />
                      
                    
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {testimonial.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {dayjs(testimonial?.created_at).fromNow()}
                      </Typography>
                    </Box>
                  </Box>

                  <StyledRating value={testimonial.rating} readOnly />

                  <TestimonialHeading variant="h6">
                    {testimonial.title}
                  </TestimonialHeading>

                  <Typography variant="body2" color="text.secondary">
                    {testimonial.content}
                  </Typography>
                </CardContent>
              </TestimonialCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;
